import { useAtomValue } from 'jotai'
import React from 'react'
import { match } from 'ts-pattern'

import { dialogInfoAtom } from '../atoms'

import { DeleteBrandGroupDialog } from './DeleteBrandGroupDialog'
import { EditBrandGroupDialog } from './EditBrandGroupDialog'

export const Dialogs = () => {
  const dialogInfo = useAtomValue(dialogInfoAtom)

  return match(dialogInfo?.dialogType)
    .with(undefined, () => null)
    .with('create', 'update', () => <EditBrandGroupDialog />)
    .with('delete', () => <DeleteBrandGroupDialog />)
    .exhaustive()
}
